/** 政策/协议 type 与接口 /api/index/chongzhi 传参一致 */
export const POLICY_TYPE = {
  REGISTER: 1,
  WITHDRAW: 2,
  USER_AGREEMENT: 3,
  PLATFORM_AGREEMENT: 4,
  USAGE_AGREEMENT: 5,
  TERMS: 6,
  PRIVACY: 7,
  COOKIE: 8
}

export const POLICY_TYPE_LABELS = {
  [POLICY_TYPE.REGISTER]: '注册说明',
  [POLICY_TYPE.WITHDRAW]: '提现说明',
  [POLICY_TYPE.USER_AGREEMENT]: '用户注册协议',
  [POLICY_TYPE.PLATFORM_AGREEMENT]: '平台协议',
  [POLICY_TYPE.USAGE_AGREEMENT]: '使用协议',
  [POLICY_TYPE.TERMS]: '合约条款',
  [POLICY_TYPE.PRIVACY]: '隐私政策',
  [POLICY_TYPE.COOKIE]: 'Cookie政策'
}

export function getPolicyTypeLabel(type) {
  const n = Number(type)
  return POLICY_TYPE_LABELS[n] || '说明'
}

export function normalizePolicyType(type, fallback = POLICY_TYPE.REGISTER) {
  const n = Number(type)
  if (Object.values(POLICY_TYPE).includes(n)) return n
  return fallback
}
